"use strict";

// alk dependency
import FleetPortalConfig from "./fleetlink.config";
import Vehicles from "./fleetlink.vehicles";
import VehicleGroups from "./fleetlink.vehicle-groups";
import Drivers from "./fleetlink.drivers";
import DriverGroups from "./fleetlink.driver-groups";
import RoutingProfiles from "./fleetlink.routing-profiles";
import FleetPortalAPI from "./fleetlink.api";
import Users from "./fleetlink.user";

export default angular.module("alk.fleetportal", [])
  .constant("alk.fleetportal.config", FleetPortalConfig)
  .service("Vehicles", Vehicles)
  .service("Drivers", Drivers)
  .service("VehicleGroups", VehicleGroups)
  .service("DriverGroups", DriverGroups)
  .service("RoutingProfiles", RoutingProfiles)
  .service("Users", Users)
  .service("FleetPortalAPI", FleetPortalAPI)
  .name;



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-fleetlink/index.js